import {
  QueryClient,
  QueryClientProvider,
  QueryCache,
  MutationCache,
} from 'react-query';
import toast from 'react-hot-toast';

const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: handleError }),
  mutationCache: new MutationCache({ onError: handleError }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry(failureCount, error: any) {
        if (error.status === 404) return false;
        if (error.status === 401) return false;
        else if (failureCount < 2) return true;
        else return false;
      },
      refetchOnMount: false,
    },
  },
});

interface ReactQueryProviderProps {
  children: React.ReactNode;
}

function ReactQueryProvider({ children }: ReactQueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}

export { ReactQueryProvider };

function handleError(error: any) {
  if (!error.status || error.status > 404) {
    toast.error(error.message ?? error.detail ?? 'Something went wrong');
  } else if (error.status === 401) {
    window.location.reload();
    return;
  }
}
